import React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../../antd/form/FormTextField/FormTextField.jsx';
import FormSwitch from '../../../../../../antd/form/FormSwitch/FormSwitch.jsx';
import FormDate from '../../../../../../antd/form/FormDate/FormDate.jsx';
import { required } from '../../../../../../antd/form/FormValidation.js';
import { Row, Col, Form, Alert, Input, Select } from 'antd'; // Ant Design grid system
import FormTextTable  from '../../../../../../antd/form/FormTextTable/FormTextTable.jsx';
import FormNumberField from '../../../../../../antd/form/FormNumberField/FormNumberField.jsx';
import FormSelect from '../../../../../../antd/form/FormSelect/FormSelect.jsx';
import FormFileUpload from '../../../../../../antd/form/FormFileUpload/FormFileUpload.jsx';
import FormHiddenField from '../../../../../../antd/form/FormHiddenField/FormHiddenField.jsx';

const PersonalData = ({
  initials,
  form,
  studyPrograms,
  study_group,
  onPreview,
  isPreview,
  isAdmin,
}) => {
  const { t } = useTranslation();
  //const [form] = Form.useForm(); // Pripojenie na Form context
  //const [averageRows, setaverageRows] = useState();
  const studyProgramsOptions = useMemo(
    () =>
      studyPrograms &&
      studyPrograms.map((item) => ({
        value: item.id,
        label: item.name,
      })),
  );
  const userMail = initials?.person?.login ?? initials?.uid;
  const receivesSocialScholarship = Form.useWatch(
    'receives_social_scholarship',
    form,
  );
  const tzp = Form.useWatch('tzp', form);

  // Dáta pre tabuľku priemerov
  const averages = [
    { key: '1', year: t('1. ročník Bc'), average: '' },
    { key: '2', year: t('2. ročník Bc'), average: '' },
    { key: '3', year: t('3. ročník Bc'), average: '' },
    { key: '4', year: t('1. ročník Ing'), average: '' },
    { key: '5', year: t('2. ročník Ing'), average: '' },
    { key: '6', year: t('1. ročník PhD'), average: '' },
    { key: '7', year: t('2. ročník PhD'), average: '' },
    { key: '8', year: t('3. ročník PhD'), average: '' },
  ];
  const bcLetter = ['Y', 'M'];
  const ingLetter = ['I', 'E'];

  const averageRows = () => {
    // if (!(typeof(study_group) == 'undefined') && bcLetter.includes(study_group.slice(2, 3))) {
    //   return averages.slice(0, Number(study_group.slice(4, 5)));
    // } else if (!(typeof(study_group) == 'undefined') && ingLetter.includes(study_group.slice(2, 3))) {
    //   return averages.slice(3, (+study_group.slice(4, 5)) + 3);
    // }
    // return averages;
    return averages.slice(0, 5);
  };

  const averageColumns = [
    {
      title: t('Rok štúdia'),
      dataIndex: 'year',
      key: 'year',
      editable: false,
    },
    {
      title: t('Priemer'),
      dataIndex: 'average',
      key: 'average',
      editable: true,
      rules: [
        {
          required: false,
          message: t('Priemer je povinný!'),
        },
      ],
    },
  ];

  return (
    <>
      <FormHiddenField name={'applicationStatus'} />
      <FormHiddenField name={'choosed_university_id'} />
      <Row gutter={[16, 16]}>
        <Col xs={12} md={8}>
          <FormTextField
            label={t('Meno')}
            name={'first_name'}
            //rules={[required(t)]}
            disabled={isAdmin && !isPreview ? false : true}
          />
        </Col>
        <Col xs={12} md={8}>
          <FormTextField
            label={t('Priezvisko')}
            name={'last_name'}
            //rules={[required(t)]}
            disabled={isAdmin && !isPreview ? false : true}
          />
        </Col>
        <Col xs={24} md={8}>
          <FormDate
            label={t('Dátum narodenia')}
            name={'birth_date'}
            rules={[required(t)]}
            disabled={isPreview}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={16}>
          <FormTextField
            label={t('Adresa')}
            name={'address'}
            rules={[required(t)]}
            disabled={isPreview}
          />
          <Alert
            title={t('Adresa musí obsahovať ulicu, číslo domu, mesto a PSČ')}
            type="info"
            showIcon
            style={{ marginBottom: 10 }}
          />
        </Col>
        <Col xs={24} md={8}>
          <Form.Item label={t('Telefón')} required>
            <Input.Group compact>
              <Form.Item
                name="phone_prefix"
                noStyle
                rules={[required(t)]}
              >
                <Select
                  style={{ width: 110 }}
                  disabled={isPreview}
                  showSearch
                  optionFilterProp="search"
                  optionLabelProp="label"
                  options={[
                    { value: '+355', search: 'Albania AL +355', label: '🇦🇱 +355' },
                    { value: '+376', search: 'Andorra AD +376', label: '🇦🇩 +376' },
                    { value: '+374', search: 'Armenia AM +374', label: '🇦🇲 +374' },
                    { value: '+43', search: 'Austria AT +43', label: '🇦🇹 +43' },
                    { value: '+375', search: 'Belarus BY +375', label: '🇧🇾 +375' },
                    { value: '+32', search: 'Belgium BE +32', label: '🇧🇪 +32' },
                    { value: '+387', search: 'Bosnia and Herzegovina BA +387', label: '🇧🇦 +387' },
                    { value: '+359', search: 'Bulgaria BG +359', label: '🇧🇬 +359' },
                    { value: '+385', search: 'Croatia HR +385', label: '🇭🇷 +385' },
                    { value: '+357', search: 'Cyprus CY +357', label: '🇨🇾 +357' },
                    { value: '+420', search: 'Czechia CZ +420', label: '🇨🇿 +420' },
                    { value: '+45', search: 'Denmark DK +45', label: '🇩🇰 +45' },
                    { value: '+372', search: 'Estonia EE +372', label: '🇪🇪 +372' },
                    { value: '+358', search: 'Finland FI +358', label: '🇫🇮 +358' },
                    { value: '+33', search: 'France FR +33', label: '🇫🇷 +33' },
                    { value: '+995', search: 'Georgia GE +995', label: '🇬🇪 +995' },
                    { value: '+49', search: 'Germany DE +49', label: '🇩🇪 +49' },
                    { value: '+30', search: 'Greece GR +30', label: '🇬🇷 +30' },
                    { value: '+36', search: 'Hungary HU +36', label: '🇭🇺 +36' },
                    { value: '+354', search: 'Iceland IS +354', label: '🇮🇸 +354' },
                    { value: '+353', search: 'Ireland IE +353', label: '🇮🇪 +353' },
                    { value: '+39', search: 'Italy IT +39', label: '🇮🇹 +39' },
                    { value: '+371', search: 'Latvia LV +371', label: '🇱🇻 +371' },
                    { value: '+423', search: 'Liechtenstein LI +423', label: '🇱🇮 +423' },
                    { value: '+370', search: 'Lithuania LT +370', label: '🇱🇹 +370' },
                    { value: '+352', search: 'Luxembourg LU +352', label: '🇱🇺 +352' },
                    { value: '+356', search: 'Malta MT +356', label: '🇲🇹 +356' },
                    { value: '+373', search: 'Moldova MD +373', label: '🇲🇩 +373' },
                    { value: '+377', search: 'Monaco MC +377', label: '🇲🇨 +377' },
                    { value: '+382', search: 'Montenegro ME +382', label: '🇲🇪 +382' },
                    { value: '+31', search: 'Netherlands NL +31', label: '🇳🇱 +31' },
                    { value: '+389', search: 'North Macedonia MK +389', label: '🇲🇰 +389' },
                    { value: '+47', search: 'Norway NO +47', label: '🇳🇴 +47' },
                    { value: '+48', search: 'Poland PL +48', label: '🇵🇱 +48' },
                    { value: '+351', search: 'Portugal PT +351', label: '🇵🇹 +351' },
                    { value: '+40', search: 'Romania RO +40', label: '🇷🇴 +40' },
                    { value: '+7', search: 'Russia RU +7', label: '🇷🇺 +7' },
                    { value: '+378', search: 'San Marino SM +378', label: '🇸🇲 +378' },
                    { value: '+381', search: 'Serbia RS +381', label: '🇷🇸 +381' },
                    { value: '+421', search: 'Slovakia SK +421', label: '🇸🇰 +421' },
                    { value: '+386', search: 'Slovenia SI +386', label: '🇸🇮 +386' },
                    { value: '+34', search: 'Spain ES +34', label: '🇪🇸 +34' },
                    { value: '+46', search: 'Sweden SE +46', label: '🇸🇪 +46' },
                    { value: '+41', search: 'Switzerland CH +41', label: '🇨🇭 +41' },
                    { value: '+90', search: 'Turkey TR +90', label: '🇹🇷 +90' },
                    { value: '+380', search: 'Ukraine UA +380', label: '🇺🇦 +380' },
                    { value: '+44', search: 'United Kingdom GB +44', label: '🇬🇧 +44' },
                    { value: '+379', search: 'Vatican City VA +379', label: '🇻🇦 +379' },
                  ]}
                />
              </Form.Item>
              <Form.Item
                name="phone_number"
                noStyle
                rules={[required(t)]}
              >
                <Input
                  style={{ width: 'calc(100% - 110px)' }}
                  disabled={isPreview}
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Alert
            title={t('Uveďte telefónne číslo s medzinárodnou predvoľbou')}
            type="info"
            showIcon
            style={{ marginBottom: 10 }}
          />
        </Col>
      </Row>

      <FormTextField
        label={t('E-mail')}
        name={'email'}
        rules={[
          required(t),
          {
            pattern: new RegExp(`^${userMail}@stud.uniza\\.sk$`),
            message: t(`E-mail musí byť vo formáte ${userMail}@stud.uniza.sk`),
          },
        ]}
        disabled={isPreview}
      />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          {/* Priemer ako tabuľka */}
          <FormTextTable
            label={t('Študijné priemery (za ukončené ročníky štúdia)')}
            name="averages"
            rows={averageRows()}
            columns={averageColumns}
            disabled={isPreview}
          />
        </Col>
        <Col xs={24} md={12}>
          <FormSelect
            label={t('Študijný program')}
            name="study_program"
            placeholder={t('Vyhľadať študijné programy')}
            options={studyProgramsOptions}
            //rules={[required(t)]}
            // disabled={isAdmin && !isPreview ? false : true}
            disabled={!isPreview ? false : true}
          />
          <FormNumberField
            label={t('Predpokladaný ročník')}
            name={'expected_study_year'}
            min={1}
            max={3}
            rules={[required(t)]}
            disabled={isPreview}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <FormSwitch
            label={t('Poberateľ sociálneho štipendia')}
            name={'receives_social_scholarship'}
            disabled={isPreview}
          />
          {receivesSocialScholarship ? (
            <FormFileUpload
              label={t('Potvrdenie o poberaní sociálneho štipendia')}
              name={'social_scholarship_path'}
              rules={[required(t)]}
              accept=".pdf"
              onPreview={onPreview}
              disabled={isPreview}
            />
          ) : (
            <FormHiddenField name={'social_scholarship_path'} />
          )}
        </Col>
        <Col span={12}>
          <FormSwitch
            label={t('Ťažko zdravotne postihnutý')}
            name={'tzp'}
            disabled={isPreview}
          />
          {tzp ? (
            <FormFileUpload
              label={t('Preukaz ŤZP')}
              name={'tzp_path'}
              rules={[required(t)]}
              accept=".pdf"
              onPreview={onPreview}
              disabled={isPreview}
            />
          ) : (
            <FormHiddenField name={'tzp_path'} />
          )}
        </Col>
      </Row>
    </>
  );
};

export default PersonalData;
